import React from 'react';
import { equipmentUsageService } from '../services/dataService';
import EquipmentUsageView from '../components/EquipmentUsageView';
import styles from './assets/css/DetailDashboard.module.css';

const EquipmentUsagePage = () => (
  <div className={styles.page}>
    <div>
      <h1>Equipment Usage</h1>
      <p className={styles.muted}>
        Worklists published to each machine, how many it pulled and how many were completed, with the issue the
        numbers point to: not pulling worklists, pulling but not sending results, or misconfigured equipment.
      </p>
    </div>
    <EquipmentUsageView fetchUsage={equipmentUsageService.get} linkEquipment />
  </div>
);

export default EquipmentUsagePage;
